import { axios } from '@Root/API'

export const create = payload => {
	return axios.post('attache/file/student-course-session', payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}
